<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>Where’d You Get That Hat?</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?dfca07cc